import { Component, OnInit, Input, ViewChildren } from "@angular/core";
import { Store } from '@ngrx/store';
import { TraceNameType, TraceStopOptions } from "src/app/services/performance.tracking.data";

type textMapType = {
  [key in TraceNameType]? : {
    message:string,
    residual?:{
      message:string,
      timeout?:number
    }
  }
} & { default?:{
  message:string
}}


@Component({
    selector: 'loader-pane-fragment',
    template: `<div #loaderfragment></div>`,
    styleUrls: ['loader-pane.sass'],
    standalone: true,
})
export class LoaderPaneFragmentComponent implements OnInit {

  @ViewChildren('loaderfragment') loaderfragment;
  @Input() trace:TraceNameType
  @Input() stopOptions:TraceStopOptions

  constructor(public store: Store){ 
    
  }

  ngOnInit() {
    // console.log("initializing loader fragment for " + this.trace)
    this.renderComplete()
  }

  renderComplete(){
    if(!this.loaderfragment) return this.renderNotComplete();
    // console.log('!!!!!!renderComplete ', this.trace, this.stopOptions)
  }

  renderNotComplete(){
    setTimeout(_=>this.renderComplete(), 500)
  }

}
